export default __webpack_public_path__ + "static/media/inactive_station_icon.e2983d06.png";